@if (mobile) {
  <section [id]="content.anchor" [class.bg-slate-50]="content.kind === 'machine'">
    @if (mobile) {
      <app-category-landing [embeddedKind]="content.kind"></app-category-landing>
    }
  </section>
} @else {
  <section
    [id]="content.anchor"
    class="py-6 md:py-8"
    [class.bg-slate-50]="content.kind === 'machine'"
  >
    <div class="mx-auto max-w-7xl px-4">
      <div class="mb-4 flex items-end justify-between gap-3 border-b border-slate-200">
        <div class="min-w-0">
          <h2 class="-mb-px inline-block border-b-2 border-emerald-600 pb-2 text-xl font-bold text-slate-900">
            {{ content.title }}
          </h2>
        </div>
        <a
          data-industry-link
          [routerLink]="listingPath"
          class="flex-none pb-2 text-sm font-medium text-emerald-700 hover:text-emerald-800 hover:underline"
        >
          {{ content.ctaLabel }}
        </a>
      </div>
      <p class="-mt-2 mb-4 break-words text-sm text-slate-600">{{ content.slogan }}</p>

      <div *ngIf="products().length; else empty" class="grid grid-cols-1 gap-3 sm:grid-cols-2 md:gap-4 lg:grid-cols-4 xl:grid-cols-5">
        <app-product-card
          *ngFor="let product of products(); trackBy: trackProduct"
          [product]="product"
        ></app-product-card>
      </div>

      <ng-template #empty>
        <div class="rounded-lg border border-dashed border-slate-300 bg-white p-6 text-center text-sm text-slate-600">
          Sản phẩm {{ content.title.toLowerCase() }} đang được cập nhật.
          <a [routerLink]="listingPath" class="font-medium text-emerald-700 hover:underline">Xem danh mục</a>
        </div>
      </ng-template>
    </div>
  </section>
}
